import RequstUrl from '../script/publicUrl'
import {WhatsAppOssGetUrl} from '../http/api'
import axiosNtLoading from 'axios'
// import {Message} from 'element-ui'
import { Toast } from 'vant-green'
function timestamp () {
  var time = new Date()
  var y = time.getFullYear()
  var m = time.getMonth() + 1
  var d = time.getDate()
  var h = time.getHours()
  var mm = time.getMinutes()
  var s = time.getSeconds()
  return '' + y + addval(m) + addval(d) + addval(h) + addval(mm) + parseInt(addval(s)) + Math.floor(Math.random() * (1000 - 1)) + 1
}
function addval (m) {
  return m < 10 ? '0' + m : m
}
// valindex 1是图片 2是视频 三是文件 chageval是页面属于那个模块1是图片 2是视频 三是文件
function ossUpload (valindex, chageval) {
  // const _this = this
  return new Promise(function (resolve, reject) {
    axiosNtLoading({
      method: 'get',
      url: RequstUrl.requestUrl + '/CRMTradeCenter/ETrade/WhatsAppOssGetPolicy',
      data: {},
      headers: {
        'Authorization-Token': window.localStorage.getItem('flagMig'),
        'Authorization-Language': window.localStorage.getItem('selectLang') || 'zh-Hans',
        'Authorization-RefSite': window.document.domain,
        'Authorization-ValidateType': 'web'
      }
    }).then(function (response) {
      if (response.data.code === 200) {
        let fileType
        if (valindex === 1) fileType = ['jpg', 'png', 'jpeg']
        if (valindex === 2) fileType = ['rb', 'rmvb', 'mp4', 'webm', 'flv']
        if (valindex === 3) fileType = ['pdf']
        const inputFile = document.createElement('input')
        inputFile.type = 'file'
        inputFile.style.display = 'none'
        document.body.appendChild(inputFile)
        inputFile.click()
        inputFile.addEventListener('change', function (red) {
          let file = inputFile.files[0]
          var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
          const KB = file.size / 1024
          if (valindex === 1 && KB > 2048) {
            Toast('尺寸不能超过2M')
            return
          } else if (chageval === 2) {
            if (valindex === 2 && KB > 10240) {
              Toast('尺寸不能超过10M')
              return
            } else if (valindex === 1 && KB > 2048) {
              Toast('尺寸不能超过2M')
              return
            }
          } else if (chageval === 3) {
            if (valindex === 3 && KB > 10240) {
              Toast('尺寸不能超过10M')
              return
            } else if (valindex === 1 && KB > 2048) {
              Toast('尺寸不能超过2M')
              return
            }
          }
          if (!fileType.includes(testmsg)) {
            if (valindex === 1) Toast('上传的文件格式只能是jpg,png,jpeg')
            if (valindex === 2) Toast('上传的文件格式只能是rb,rmvb,mp4,webm,flv')
            if (valindex === 3) Toast('上传的文件格式只能是xls,xlsx,et,txt,pdf')
            document.body.removeChild(inputFile)
            return false
          }
          const data = response.data.result
          const formData = new FormData()
          // const lastval = file.type.substring(0, file.type.indexOf('/'))
          // const lastval1 = file.type.substring(lastval.length + 1, file.type.length)
          const lastval1 = file.name.substring(file.name.lastIndexOf('.'))
          const bubiandata = data.dir + timestamp() + lastval1
          formData.append('name', file.name)
          formData.append('key', bubiandata)
          formData.append('policy', data.policy)
          formData.append('OSSAccessKeyId', data.accessid)
          formData.append('success_action_status', 200)
          formData.append('callback', '')
          formData.append('signature', data.signature)
          formData.append('file', file)
          // _this.adddata.Name = _this.box1dialogData.Name
          // if (valindex === 1) _this.adddata.ThumbUrl = bubiandata
          // if (valindex !== 1) _this.adddata.Url = bubiandata
          // if (chageval === 1) _this.adddata.Size = KB
          // if (chageval !== 1 && valindex !== 1) _this.adddata.Size = KB
          // if (chageval === 1) _this.adddata.Type = 'img'
          // if (chageval === 2) _this.adddata.Type = 'video'
          // if (chageval === 3) _this.adddata.Type = 'file'
          axiosNtLoading({
            method: 'post',
            url: data.host,
            data: formData,
            headers: {
              'Authorization-Token': window.localStorage.getItem('flagMig'),
              'Authorization-ValidateType': 'web',
              'Authorization-Language': window.localStorage.getItem('selectLang') || 'zh-Hans',
              'Content-Type': 'multipart/form-data; boundary=----WebKitFormBoundarynl6gT1BKdPWIejNq'
            }
          }).then(function (res) {
            let databbj = {
              key: bubiandata,
              minute: 10800
            }
            WhatsAppOssGetUrl(databbj, 'has').then(response => {
              if (response.code === 200) {
                // if (valindex === 2) _this.dialogvideoUrl = response.result
                // if (valindex === 3) _this.dialogpdfUrl = response.result
                // _this.dialogImageUrl = response.result
                const dataddd = {
                  url: response.result,
                  link: bubiandata,
                  size: KB.toFixed(2),
                  filename: file.name
                }
                resolve(dataddd)
              }
            })
          })
        })
      }
    })
  })
}
export default ossUpload



// WEBPACK FOOTER //
// ./src/script/ossUpload.js